import { fileDownload } from "../ask/axios";

import { post, fetch } from "@/ask/axios";

import { getCookie, setCookie } from "@/ask/cookiejs";

/** 打印标签操作人参数（供应商中心） */
export function getPrintLabelOperatorParams() {
  let userInfo = {};
  try {
    const info = localStorage.getItem("userInfo");
    if (info) {
      userInfo = JSON.parse(info);
    }
  } catch (e) {}
  return {
    OperationSource: "SUPPLIER_CENTER",
    PrintSubject: "SUPPLIER",
    OperatorId: userInfo.SupplierID || "",
    Operator: userInfo.SupplierName || "",
  };
}

// 手机号正则
export const mobilePhoneRegExp = /^1\d{10}$/;

//普通电话
export const tel = /^(\(\d{3,4}\)|\d{3,4}-)?\d{7,8}$/;
//  传真
export const telFax = /^(?:\d{3,4}-)?\d{7,8}(?:-\d{1,6})?$/; //区号（3到4位数字）+电话号码（7到8位数字）+分机号（1到6位数字） 例如：010-26737123-888
///^[+]{0,1}(\d){1,3}[ ]?([-]?((\d)|[ ]){1,12})+$/;

// 正则匹配中文，英文，数字
export const nameRegExp = /^(?!_)(?!.*?_$)[a-zA-Z0-9\u4e00-\u9fa5]{1,20}$/;
export const nameRegExp10 = /^(?!_)(?!.*?_$)[a-zA-Z0-9\u4e00-\u9fa5]{1,10}$/;
// 正则匹配汉字
export const chineseExp = /[\u4e00-\u9fa5]/;

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string") {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), "/");
      }
    }

    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}

export default {
  install(Vue, options) {
    (Date.prototype.Format = function (fmt) {
      if (!this.Valid()) {
        return "";
      }

      var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        S: this.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (this.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      }
      return fmt;
    }),
      //判断是否有效日期
      (Date.prototype.Valid = function () {
        return isFinite(this);
      });
    //注意：此方法会导致阻塞，请慎用
    //等待funCheck的验证通过后，执行funRun
    //funCheck验证方法，此方法必须返回bool型
    //funRun需执行的方法
    //maxWaitMillisecond最多等待时间（单位：毫秒）
    (Vue.prototype.waitRun = function (funCheck, funRun, maxWaitMillisecond) {
      //console.log(maxWaitMillisecond + " " + new Date());
      if (maxWaitMillisecond == null || maxWaitMillisecond == undefined) {
        maxWaitMillisecond = 1000 * 10; //默认最多等待10秒
      }

      if (funCheck() == true || maxWaitMillisecond <= 0) {
        //验证通过，或等待时间已过 执行方法
        funRun();
      } else {
        //验证不通过，等待
        setTimeout(() => {
          this.waitRun(funCheck, funRun, maxWaitMillisecond - 100);
        }, 100);
      }
    }),
      //当小数不足bit时，不补0，超过bit 截取bit位
      // num 数字  bit 位数
      (Vue.prototype.InterceptUnit = function (num, bit) {
        if (num) {
          return parseFloat(Number(num).toFixed(bit));
        } else {
          return 0;
        }
      }),
      /**
       * 获取上N个月
       *
       * @date 格式为yyyy-mm-dd的日期，如：2014-01-25
       * monthNum 要上N个月
       */
      (Vue.prototype.getPreMonth = function (date, monthNum) {
        // console.log('days= ' + JSON.stringify(date));
        var arr = date.split("-");
        var year = arr[0]; //获取当前日期的年份
        var month = arr[1]; //获取当前日期的月份
        var day = arr[2]; //获取当前日期的日
        var days = new Date(year, month, 0);

        days = days.getDate(); //获取当前日期中月的天数
        var year2 = year;
        var month2 = parseInt(month) - monthNum;
        if (month2 == 0) {
          year2 = parseInt(year2) - 1;
          month2 = 12;
        }
        var day2 = day;
        var days2 = new Date(year2, month2, 0);
        days2 = days2.getDate();
        if (day2 > days2) {
          day2 = days2;
        }
        if (month2 < 10) {
          month2 = "0" + month2;
        }
        var t2 = year2 + "-" + month2 + "-" + day2;
        console.log("t2= " + JSON.stringify(new Date(t2).Format("yyyy-MM-dd")));
        return t2;
      }),
      /**
       * 获取下一个月
       *
       * @date 格式为yyyy-mm-dd的日期，如：2014-01-25
       */
      (Vue.prototype.getNextMonth = function (date) {
        var arr = date.split("-");
        var year = arr[0]; //获取当前日期的年份
        var month = arr[1]; //获取当前日期的月份
        var day = arr[2]; //获取当前日期的日
        var days = new Date(year, month, 0);
        days = days.getDate(); //获取当前日期中的月的天数
        var year2 = year;
        var month2 = parseInt(month) + 1;
        if (month2 == 13) {
          year2 = parseInt(year2) + 1;
          month2 = 1;
        }
        var day2 = day;
        var days2 = new Date(year2, month2, 0);
        days2 = days2.getDate();
        if (day2 > days2) {
          day2 = days2;
        }
        if (month2 < 10) {
          month2 = "0" + month2;
        }

        var t2 = year2 + "-" + month2 + "-" + day2;
        return t2;
      });
    // Currency 1：CNY，2：USD，3：HKD，4：EUR
    Vue.prototype.getMoneySymbol = function (index) {
      let i = Number(index);
      let moneySymbol = ["¥", "$", "HK$", "€"];
      return moneySymbol[i - 1];
    };
    (Vue.prototype.newDate = function (data) {
      // 返回正确得日期格式
      if (data) {
        data = data.replace(new RegExp(/-/gm), "/");
        // 如果来得格式
        if (data.indexOf("T") !== -1) {
          data = data.replace(new RegExp(/T/gm), " ");
        }
        return new Date(data);
      } else {
        return new Date();
      }
    }),
      (Vue.prototype.dateChange = function (num = 0, date = false) {
        if (!date) {
          date = new Date(); //没有传入值时,默认是当前日期
          date =
            date.getFullYear() +
            "-" +
            (date.getMonth() + 1) +
            "-" +
            date.getDate();
          return date;
        }
        let getDate = date;
        getDate += " 00:00:00";
        getDate = Date.parse(new Date(date)) / 1000;
        getDate += 86400 * num; //修改后的时间戳
        var newDate = new Date(parseInt(getDate) * 1000);
        let giveDate =
          newDate.getFullYear() +
          "-" +
          (newDate.getMonth() + 1) +
          "-" +
          newDate.getDate();
        return giveDate;
      }),
      /**
       * @description: 去除所有空格
       * @param {String} val
       * @return {String}
       */
      (Vue.prototype.removeSpaces = function (val) {
        if (Object.prototype.toString.call(val) !== "[object String]") {
          console.error(val + " must need string, plz");
        } else {
          return String(val).replace(/\s+/g, "");
        }
      });

    Vue.prototype.getPrintLabelOperatorParams = getPrintLabelOperatorParams;
  },
};
//随机生成手机号
export function getMoble() {
  var prefixArray = new Array(
    "130",
    "131",
    "132",
    "133",
    "135",
    "137",
    "138",
    "170",
    "187",
    "189"
  );

  var i = parseInt(10 * Math.random());

  var prefix = prefixArray[i];
  prefix = prefix + "****";
  for (var j = 0; j < 4; j++) {
    prefix = prefix + Math.floor(Math.random() * 10);
  }
  prefix;
  return prefix;
}

// 以下JS函数用于获取url参数:
export function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}
//去除字符串中的字母
export function dislodgeLetter(str) {
  var result;
  var reg = /[a-zA-Z]+/; //[a-zA-Z]表示匹配字母，g表示全局匹配
  while ((result = str.match(reg))) {
    //判断str.match(reg)是否没有字母了
    str = str.replace(result[0], ""); //替换掉字母  result[0] 是 str.match(reg)匹配到的字母
  }
  return str;
}
/*
 * 获取今天，明天，后天的日期 num 为-1 昨天  num为-2 前天
 * TimeStart 开始服务时间 由后台数据返回
 * TimeEnd 结束服务时间 由后台数据返回
 */
export function getDay(num, str, TimeStart, TimeEnd, strTime = ":") {
  var dayTime = new Date();
  dayTime.setTime(dayTime.getTime() + 24 * 60 * 60 * 1000 * num);
  // 计算三天日期
  let year, month, day, dayData;
  year = dayTime.getFullYear();
  month =
    dayTime.getMonth() + 1 < 10
      ? "0" + (dayTime.getMonth() + 1)
      : dayTime.getMonth() + 1;
  day = dayTime.getDate() < 10 ? "0" + dayTime.getDate() : dayTime.getDate();
  dayData = year + str + month + str + day;
  // 当前日期 时间
  let dayNew = new Date();
  let yearNew, monthNew, daysNew, dayDataNew, HH, MM;
  yearNew = dayNew.getFullYear();
  monthNew =
    dayNew.getMonth() + 1 < 10
      ? "0" + (dayNew.getMonth() + 1)
      : dayNew.getMonth() + 1;
  daysNew = dayNew.getDate() < 10 ? "0" + dayNew.getDate() : dayNew.getDate();
  dayDataNew = yearNew + str + monthNew + str + daysNew;
  // let newtoLocale = dayNew.toLocaleDateString().replace(/\//g, '-');

  MM =
    dayTime.getMinutes() < 10
      ? "0" + dayTime.getMinutes()
      : dayTime.getMinutes();
  HH = dayTime.getHours() < 10 ? "0" + dayTime.getHours() : dayTime.getHours();

  var newHours =
    (MM > 30 ? parseInt(HH, 10) + 1 : HH) +
    strTime +
    (MM > 30 ? parseInt(MM, 10) - 30 : parseInt(MM, 10) + 30) +
    strTime +
    "00";
  // 常规24小时 加半个小时
  let HTimes = [];
  let Time = {};
  let dayHour = 0;
  for (var j = 0; j < 48; j++) {
    if (j < 10 * 2) {
      if (j % 2 == 0) {
        dayHour = "0" + parseInt(j / 2) + ":" + "00" + ":" + "00";
      } else {
        dayHour = "0" + parseInt(j / 2) + ":" + "30" + ":" + "00";
      }
    } else {
      if (j % 2 == 0) {
        dayHour = parseInt(j / 2) + ":" + "00" + ":" + "00";
      } else {
        dayHour = parseInt(j / 2) + ":" + "30" + ":" + "00";
      }
    }
    Time = {
      Time: dayHour,
    };
    HTimes.push(Time);
  }
  // 根据后台返回时间范围计算时间
  let addTime = [];
  // console.log(dayDataNew, "71s", dayData,"4",newHours)
  HTimes.forEach((items) => {
    if (TimeEnd) {
      if (TimeStart <= items.Time && items.Time <= TimeEnd) {
        if (dayDataNew == dayData) {
          if (newHours < items.Time) {
            console.log(newHours, "sjsdj", items.Time);
            addTime.push(items);
          }
        } else {
          addTime.push(items);
        }
      }
    } else {
      if (dayDataNew == dayData) {
        if (newHours < items.Time) {
          addTime.push(items);
        }
      } else {
        addTime.push(items);
      }
    }
  });

  var dayTimeS = {
    Date: dayData,
    Times: addTime,
  };

  return dayTimeS;
}

//查价-- 比重段匹配值 45  XX表示当前数值
export function getProportionKG(XX) {
  XX = Number(XX);
  let ProportionValue = "";
  // 45KG +
  if (XX < 45 || (45 <= XX && XX <= 99)) {
    ProportionValue = 45;
  }

  // 100KG +
  if (100 <= XX && XX <= 299) {
    ProportionValue = 100;
  }

  // 300KG +
  if (300 <= XX && XX <= 499) {
    ProportionValue = 300;
  }

  // 500KG+
  if (500 <= XX && XX <= 999) {
    ProportionValue = 500;
  }

  // 1000KG+
  if (1000 <= XX) {
    ProportionValue = 1000;
  }
  return ProportionValue;
}
//详情tab切换-- 比重段匹配值 1:300  XX表示当前数值
export function getProportionCBM(XX) {
  XX = Number(XX);
  let ProportionValue = "";
  // 默认重量 167KG
  if (XX < 300) {
    ProportionValue = 167;
  }

  // 默认重量 300KG
  if (300 <= XX && XX <= 499) {
    ProportionValue = 300;
  }

  // 默认重量 500KG
  if (500 <= XX && XX <= 999) {
    ProportionValue = 500;
  }

  // 默认重量 1000KG
  if (1000 <= XX) {
    ProportionValue = 1000;
  }

  return ProportionValue;
}

// // 传入一个数组
// // 按照特定方式格式化
// export function sortArr(arr, str) {
//     var _arr = [],
//         _t = [],
//         // 临时的变量
//         _tmp;

//      // 按照特定的参数将数组排序将具有相同值得排在一起
//      arr = arr.sort(function(a, b) {
//          var s = a[str],
//              t = b[str];

//          return s < t ? -1 : 1;
//      });

//      if ( arr.length ){
//          _tmp = arr[0][str];
//      }
//      // console.log( arr );
//      // 将相同类别的对象添加到统一个数组
//      for (var i in arr) {
//          // console.log( _tmp);
//          if ( arr[i][str] === _tmp ){
//              // console.log(_tmp)
//              _t.push( arr[i] );
//          } else {
//              _tmp = arr[i][str];
//              _arr.push( _t );
//              _t = [arr[i]];
//          }
//      }
//      // 将最后的内容推出新数组
//      _arr.push( _t );
//      return _arr;
//  }

// 传入一个数组
// 按照特定方式格式化
export function sortArr(arr, str, str1) {
  var _arr = [],
    _t = [],
    // 临时的变量
    _tmp,
    _tmp1,
    // 按照特定的参数将数组排序将具有相同值得排在一起
    arr = arr.sort(function (a, b) {
      var s = a[str],
        t = b[str];

      var s1 = a[str1],
        t1 = b[str1];

      return (s < t ? -1 : 1) && (s1 < t1 ? -1 : 1);
    });

  if (arr.length) {
    _tmp = arr[0][str];
    _tmp1 = arr[0][str1];
  }

  console.log(arr);

  // 将相同类别的对象添加到统一个数组
  for (var i in arr) {
    if (arr[i][str] === _tmp && arr[i][str1] === _tmp1) {
      _t.push(arr[i]);
    } else {
      _tmp = arr[i][str];

      _tmp1 = arr[i][str1];

      _arr.push(_t);
      _t = [arr[i]];
    }
  }
  // 将最后的内容推出新数组
  _arr.push(_t);
  return _arr;
}

/**
 * @desc 数据类型检测
 * @param obj 待检测的数据
 * @return {String} 类型字符串
 */
export function dataType(obj) {
  return typeof obj !== "object"
    ? typeof obj
    : Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
}

/**
 * 防抖函数
 */
export function debounce(fun, delay) {
  return function (args) {
    let that = this;
    let _args = args;
    clearTimeout(fun.id);
    fun.id = setTimeout(function () {
      fun.call(that, _args);
    }, delay);
  };
}

/**
 * 节流函数
 */
export function throttle(func, wait) {
  let timeout;
  return function () {
    let context = this;
    let args = arguments;
    if (!timeout) {
      timeout = setTimeout(() => {
        timeout = null;
        func.apply(context, args);
      }, wait);
    }
  };
}

//计算两个日期之间相差的天数
export function getDiffDay(date_1, date_2) {
  // 计算两个日期之间的差值
  let totalDays, diffDate;
  let myDate_1 = Date.parse(date_1);
  let myDate_2 = Date.parse(date_2);
  // 将两个日期都转换为毫秒格式，然后做差
  diffDate = Math.abs(myDate_1 - myDate_2); // 取相差毫秒数的绝对值

  totalDays = Math.floor(diffDate / (1000 * 3600 * 24)); // 向下取整
  // console.log(totalDays)

  return totalDays; // 相差的天数
}

// 获取当前日期的上一个月
export function getlastMonth() {
  let now = new Date();
  // 当前月的日期
  let nowDate = now.getDate();
  let lastMonth = new Date(now.getTime());
  // 设置上一个月（这里不需要减1）
  lastMonth.setMonth(lastMonth.getMonth());
  // 设置为0，默认为当前月的最后一天
  lastMonth.setDate(0);
  // 上一个月的天数
  let daysOflastMonth = lastMonth.getDate();
  // 设置上一个月的日期，如果当前月的日期大于上个月的总天数，则为最后一天
  lastMonth.setDate(nowDate > daysOflastMonth ? daysOflastMonth : nowDate);
  return lastMonth;
}

/**
 * @description:下载导出文件流
//  * @param { string } method  请求 api 方法类型
//  * @param { string } url  请求 api 地址
 * @param { object } vm this
 * @param { object } params  请求 api 传递的参数
 * @param { string } fileName 导出文件名称, 需要加后缀名
*/
export function fileSteamDownload(vm, params, fileName) {
  fileDownload("get", vm.$api04 + "/File/api/FileHandle/Download", params).then(
    (res) => {
      // 把后台传过来的文件流转化成blob url路径下载
      const hrefUrl = window.URL.createObjectURL(
        new Blob([res.data], {
          type: "application/vnd.opencmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      // 创建一个a标签下载文件
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = hrefUrl;
      // 设置文件名称、后缀名
      link.download = decodeURIComponent(fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // 释放内存
      window.URL.revokeObjectURL(hrefUrl);
    }
  );
}
/**
 * @description: 下载导出base64编码
//  * @param { string } method  请求 api 方法类型
//  * @param { string } url  请求 api 地址
 * @param { object } vm this
 * @param { object } params  请求 api 传递的参数
 * @param { string } fileName 导出文件名称, 需要加后缀名
*/
export function downloadFileSteam(vm, params, fileName) {
  return new Promise(async (resolve, reject) => {
    let url = "";
    await fileDownload(
      "get",
      vm.$api04 + "File/api/FileHandle/Download",
      params
    ).then((res) => {
      // 把后台传过来的文件流转化成blob url路径下载
      let blob = new Blob([res.data]);
      // );
      // 创建一个a标签下载文件
      let oFileReader = new FileReader();
      oFileReader.onloadend = function (e) {
        // 结果
        console.log(e.target.result);
        url = e.target.result;
        resolve(url);
      };
      oFileReader.readAsDataURL(blob);
      return false;
      // 释放内存
      // window.URL.revokeObjectURL(hrefUrl);
    });
  });
}

function getBlob(url) {
  return new Promise((resolve) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.response);
      }
    };
    xhr.send();
  });
}
function saveAs(blob, filename) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, filename);
  } else {
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(link.href);
  }
}
/**
 * @description 下载文件，兼容IE
 * @param { string } url 文件下载地址
 * @param { string } fileName 设置下载文件的名字(需要后缀名)
 */
export function downloadFile(url, fileName) {
  // 判断是否是IE
  if (!!window.ActiveXObject || "ActiveXObject" in window) {
    // IE
    getBlob(url).then((blob) => {
      saveAs(blob, fileName);
    });
  } else {
    // 创建隐藏的可下载链接
    var eleLink = document.createElement("a");
    eleLink.target = "_blank";
    eleLink.download = fileName;
    eleLink.style.display = "none";
    eleLink.href = url;
    // 触发点击
    document.body.appendChild(eleLink);
    eleLink.click();
    // 然后移除
    document.body.removeChild(eleLink);
  }
}

// 判断是否是已认证的用户, 获取用户信息
export function getAccountInfo(vm, type = 0) {
  return new Promise(async (resolve, reject) => {
    if (true) {
      // 判断是否存在用户信息
      if (type == 0) {
        if (
          getCookie("userInfo") &&
          ![null, "null", undefined, "undefined"].includes(
            getCookie("userInfo")
          )
        ) {
          let CustomerInfo = getCookie("userInfo");
          localStorage.setItem("userInfo", JSON.stringify(Results));
          return resolve(JSON.parse(CustomerInfo || ""));
        }
      }

      await post(vm.$api04 + "/BasicsSupplier/api/SupplierInfo/Query", {})
        .then((res) => {
          if (res.IsOK) {
            let userInfo = res.Results.length > 0 ? res.Results[0] : '';
            
            setCookie("userInfo", JSON.stringify(userInfo));
            localStorage.setItem("userInfo", JSON.stringify(userInfo));
            return resolve(res.Results.length > 0 ? res.Results[0] : {});
          } else {
            return resolve({});
          }
        })
        .catch((err) => {
          return resolve({});
        });
    } else {
      return reject();
    }
  });
}

// 获取资质认证状态列表
export function getAuthenticationStatusList(vm, type = 0) {
  return new Promise(async (resolve, reject) => {
    if (true) {
      // 判断是否存在用户信息
    //   if (type == 0) {
    //     if (
    //       getCookie("AuthenticationStatusList") &&
    //       ![null, "null", undefined, "undefined"].includes(
    //         getCookie("AuthenticationStatusList")
    //       )
    //     ) {
    //       let AuthenticationStatusList = getCookie("AuthenticationStatusList");
    //       sessionStorage.setItem("AuthenticationStatusList", JSON.stringify(Results));
    //       return resolve(JSON.parse(AuthenticationStatusList || ""));
    //     }
    //   }

      await post(vm.$api04 + "/BasicsSupplier/api/SupplierInfo/QueryQualifyAuditStatus", {})
        .then((res) => {
          if (res.IsOK) {
            console.log(res.Results, "11111AuthenticationStatusList");
            // setCookie("AuthenticationStatusList", JSON.stringify(res.Results));
            // sessionStorage.setItem("AuthenticationStatusList", JSON.stringify(Results));
            console.log(res.Results, "AuthenticationStatusList");
            return resolve(res.Results || []);
          } else {
            return resolve({});
          }
        })
        .catch((err) => {
          return resolve({});
        });
    } else {
      return reject();
    }
  });
}


